import AutomationImage from "../../../assets/images/home-page/benefits/automation.png";
import FeedbackImage from "../../../assets/images/home-page/benefits/feedback.png";
import AccessImage from "../../../assets/images/home-page/benefits/accessFromDevices.png";
import TransparentImage from "../../../assets/images/home-page/benefits/tariffs.png";
import IntegrationImage from "../../../assets/images/home-page/benefits/integration.png";
import DialogImage from "../../../assets/images/home-page/benefits/dialog.png";


const benefitsList = [
  {
    icon: { AutomationImage },
    link: "/automation-and-optimization",
    manualKey: "benefitsAutomation",
    title: "Automation and optimization.",
    description: "Tickets, client communication templates, chat settings in accordance with the color scheme of the site, which will speed up the processing of applications and save time."
  },
  {
    icon: { FeedbackImage },
    link: "/feedback-and-control-of-correspondence",
    manualKey: "benefitsFeedback",
    title: " Feedback and control of correspondence",
    description: "When the online chat between the two parties (client and support) is over, based on the dialogue, you can make a report on the quality and speed of customer service."
  },
  {
    icon: { AccessImage },
    link: "/access-from-any-device-at-any-time",
    manualKey: "benefitsAccess",
    title: "Access from any device at any time.",
    description: "Our chat supports synchronization with Android, iOS, Linux, MacOS and Windows. Chat with your customers at a convenient time for you, without being tied to any place."
  },
  {
    icon: { TransparentImage },
    link: "/transparent-and-understandable-rates",
    manualKey: "benefitsTransparent",
    title: "Transparent and understandable rates.",
    description: "Unlimited number of contacts and chats, at a favorable price, which can be calculated individually for each client. Free trial version of the chat to test all the features."
  },
  {
    icon: { IntegrationImage },
    link: "/integration-with-other-messengers",
    manualKey: "benefitsIntegration",
    title: "Integration with other messengers.",
    description: "The multi-channel nature of our chat supports interaction with other popular chats and instant messengers: Viber, Telegram, etc. Be always in touch with your customers."
  },
  {
    icon: { DialogImage },
    link: "/chat-with-several-users-at-once",
    manualKey: "benefitsAbility",
    title: "Chat with several users at once.",
    description: "By phone, this process could only be done with one client to give him enough time, and live online chat allows you to conduct several correspondences at the same time."
  }
];

export {
  benefitsList
};